export default __webpack_public_path__ + "locales/lv/Files.json?hash=4ea02a9de20b19d6bcc1d2a47f35333a";